import {
  getMockResponse,
  setMockResponse,
} from "@redotech/rpc-mock/mock-storage";

const mockInventoryProducts = [
  {
    id: "prd_MOCK0001",
    productFamilyId: "pfm_MOCK0001",
    title: "Redo Classic Tee - Blue / Medium",
    sku: "TEE-BLU-M-001",
    upc: "012345678901",
    vendor: "Redo Apparel Co.",
    image: "https://picsum.photos/seed/tshirt/80/80",
    tags: ["clothing", "summer", "sale", "featured", "new-arrival", "eco"],
    variantTags: ["blue", "medium", "cotton", "unisex"],
    productFamilyTags: ["tops", "t-shirts", "apparel"],
    totalQuantity: 150,
    totalBuildable: 150,
    totalAvailable: 120,
    totalCommitted: 20,
    totalReserved: 10,
    reservedBuckets: [],
    cost: 12.5,
    price: 29.99,
    currency: "USD",
    accountId: "mock-account-1",
    accountName: "Redo Dev Store",
    incomingShipmentCount: 1,
    incomingUnits: 50,
    inventoryValue: 1875,
    inventoryValueCurrency: "USD",
    retailValue: 4498.5,
    retailValueCurrency: "USD",
    locations: [],
    productStatus: "ACTIVE",
    forecastingEnabled: false,
    suppliers: [],
    purchaseOrderCount: 0,
  },
  {
    id: "prd_MOCK0002",
    productFamilyId: "pfm_MOCK0002",
    title: "Premium Hoodie - Black / Large",
    sku: "HOODIE-BLK-L-002",
    vendor: "Redo Apparel Co.",
    image: "https://picsum.photos/seed/hoodie/80/80",
    tags: ["clothing", "winter", "premium", "bestseller"],
    variantTags: ["black", "large", "fleece"],
    productFamilyTags: ["tops", "hoodies", "outerwear", "apparel"],
    totalQuantity: 75,
    totalBuildable: 75,
    totalAvailable: 60,
    totalCommitted: 10,
    totalReserved: 5,
    reservedBuckets: [],
    cost: 25.0,
    price: 59.99,
    currency: "USD",
    accountId: "mock-account-1",
    accountName: "Redo Dev Store",
    incomingShipmentCount: 0,
    incomingUnits: 0,
    inventoryValue: 1875,
    inventoryValueCurrency: "USD",
    retailValue: 4499.25,
    retailValueCurrency: "USD",
    locations: [],
    productStatus: "ACTIVE",
    forecastingEnabled: false,
    suppliers: [],
    purchaseOrderCount: 1,
  },
  {
    id: "prd_MOCK0003",
    productFamilyId: "pfm_MOCK0003",
    title: "Cargo Shorts - Khaki / Small",
    sku: "SHORTS-KHK-S-003",
    upc: "012345678903",
    vendor: "Redo Outdoor",
    image: "https://picsum.photos/seed/shorts/80/80",
    tags: ["clothing", "summer", "outdoor", "sale"],
    variantTags: ["khaki", "small"],
    productFamilyTags: ["bottoms", "shorts"],
    totalQuantity: 30,
    totalBuildable: 30,
    totalAvailable: 28,
    totalCommitted: 2,
    totalReserved: 0,
    reservedBuckets: [],
    cost: 18.0,
    price: 44.99,
    currency: "USD",
    accountId: "mock-account-1",
    accountName: "Redo Dev Store",
    incomingShipmentCount: 0,
    incomingUnits: 0,
    inventoryValue: 540,
    inventoryValueCurrency: "USD",
    retailValue: 1349.7,
    retailValueCurrency: "USD",
    locations: [],
    productStatus: "ACTIVE",
    forecastingEnabled: false,
    suppliers: [],
    purchaseOrderCount: 0,
  },
];

export function registerMerchantMockRpcResponses(): void {
  if (getMockResponse("checkActiveEscalation") === undefined) {
    setMockResponse("checkActiveEscalation", { activeEscalation: null });
  }
  if (getMockResponse("getInventoryProductsCount") === undefined) {
    setMockResponse("getInventoryProductsCount", {
      totalCount: mockInventoryProducts.length,
      hasMultipleMerchants: false,
    });
  }
  if (getMockResponse("getInventoryProducts") === undefined) {
    setMockResponse("getInventoryProducts", {
      products: mockInventoryProducts,
      hasMultipleMerchants: false,
    });
  }
}
